export default __webpack_public_path__ + "staticlp1/media/credit-card-american-express.6cb2776f.png";